// AboutSigmaStudio.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Think5WhysHelp.css';
const AboutLifeChronicle = () => {
  const topics = [
    {
      title: "Our Life Chronicle",
      description: (
        <div>
          <p>
           Life is a series of chapters, each unfolding with its own story, challenges, and growth. 
           Embrace the journey, for every page turned adds depth to the chronicles of your existence.

           Further life unfolds like a grand book, each chapter with its own tale. Challenges and growth shape our narrative. 
           Every turn adds depth to our existence. Embrace the journey; challenges push growth. Surrender to life's flow, 
           learn from every twist. Life's surprises enrich us. Embrace the unknown, discover its magic. 
           Every page adds depth. Our resilience and growth shine through. Each chapter contributes to our journey.
          </p><br/>
          <p>
            These chronicles include:
            <br/><br/>
            <ul>
            <li><strong>The Journey of Self-Discovery:</strong> Exploring one's identity, values, and passions.</li>
            <li><strong>Triumph Over Adversity:</strong> Overcoming challenges and obstacles to achieve success.</li>
            <li><strong>The Quest for Meaning:</strong> Seeking purpose and fulfillment in life's experiences.</li>
            <li><strong>Love and Relationships:</strong> Navigating the complexities of friendship, romance, and family dynamics.</li>
            <li><strong>The Pursuit of Knowledge:</strong> Lifelong learning and intellectual growth.</li>
            <li><strong>Spiritual Awakening:</strong> Exploring beliefs, faith, and personal spirituality.</li>
            <li><strong>The Adventure of Travel:</strong> Discovering new cultures, landscapes, and experiences around the world.</li>
            <li><strong>Career Evolution:</strong> Developing skills, pursuing ambitions, and navigating professional paths.</li>
            <li><strong>Parenthood and Family Bonds:</strong> Raising children, building connections, and nurturing relationships.</li>
            <li><strong>Legacy and Contribution:</strong> Leaving a positive impact on the world, whether through philanthropy, creativity, or mentorship.</li>
          </ul>
          </p>
        </div>
      ),
    },
    {
      title: "Tasks & Trails",
      description: (
        <div>
          <p>
            A task is a specific action to be completed. In Think5Whys, you manage your own tasks list or tasks assigned to others.
          </p>
        </div>
      ),
    },
    {
      title: "Eventful Horizons",
      description: (
        <div>
          <p>
            An event is a gathering or occurrence, often involving multiple people. In Think5Whys, you manage your own event list or other events important to you.
          </p>
        </div>
      ),
    },
    {
      title: "Memoirs of Memories",
      description: (
        <div>
          <p>
            A memory is a recollection of past experiences stored in the mind. In Think5Whys, you manage your own memory list.
          </p>
        </div>
      ),
    },
    {
      title: "Journey of Experience",
      description: (
        <div>
          <p>
            An experience is a broader term encompassing various moments and encounters. In Think5Whys, you manage your own experience list.
          </p>
        </div>
      ),
    },
    {
      title: "Invitations to Joy",
      description: (
        <div>
          <p>
            An invitation is a request to attend a specific event or activity. In Think5Whys, you manage your own event list or events you have or wish to attend.
          </p>
        </div>
      ),
    },
    {
      title: "Gratitude's Tapestry",
      description: (
        <div>
          <p>
            Gratitude is the state of being thankful or appreciative. In Think5Whys, you manage your own gratitude list and share a short thankyou message.
          </p>
        </div>
      ),
    },
    {
      title: "Empathy's Embrace",
      description: (
        <div>
          <p>
            Empathy is the ability to understand and share the feelings of others. In Think5Whys, you manage your own empathy list and share a short empathy message.
          </p>
        </div>
      ),
    },
    {
      title: "Sympathetic Echoes",
      description: (
        <div>
          <p>
            Sympathy is Recognizing and expressing compassion for others' challenges without shared emotions. In Think5Whys, you manage your own sympathy list and share a short message.
          </p>
        </div>
      ),
    },
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>About Think5Whys LifeChronicle</h2>
      </div>
      <div className="help-container">
        <ul className="help-list">
          {topics.map((topic, index) => (
            <li key={index} onClick={() => handleTopicClick(index)} className="help-topic">
              {topic.title}
              {expandedTopic === index && (
                <div className="help-description">
                  <p>{topic.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default AboutLifeChronicle;


